import { render, staticRenderFns } from "./photo-plug.vue?vue&type=template&id=0e84fcbf&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/photo-plug/photo-plug.vue
// module id = 1487
// module chunks = 0